import { Pane, Text, Badge, IconButton, RepeatIcon, EditIcon, TrashIcon, ChevronDownIcon, ChevronUpIcon } from 'evergreen-ui';

const PERIOD_COLORS = { giorno: 'blue', notte: 'neutral', coda_della_notte: 'orange' };
const PERIOD_LABELS = { giorno: 'Giorno', notte: 'Notte', coda_della_notte: 'Coda notte' };

const fmtDate = (d) => d ? d.split('-').reverse().join('/') : '?';
const fmtTime = (t) => t ? t.substring(0, 5) : '?';

export default function TurniRangesList({ shiftRanges, showRanges, setShowRanges, onEdit, onDelete }) {
  if (!shiftRanges.length) return null;

  return (
    <Pane marginBottom={24} background="white" border="default" borderRadius={8} overflow="hidden">
      <Pane
        display="flex" alignItems="center" justifyContent="space-between"
        padding={12} background="tint2" cursor="pointer"
        onClick={() => setShowRanges(v => !v)}
      >
        <Pane display="flex" alignItems="center" gap={8}>
          <RepeatIcon color="muted" size={16} />
          <Text fontWeight="bold" size={400}>Orari fissi assegnati ({shiftRanges.length})</Text>
        </Pane>
        {showRanges ? <ChevronUpIcon color="muted" /> : <ChevronDownIcon color="muted" />}
      </Pane>

      {showRanges && (
        <Pane display="flex" flexDirection="column">
          {shiftRanges.map((r, idx) => (
            <Pane
              key={r.batch_id}
              display="flex" alignItems="center" justifyContent="space-between"
              flexWrap="wrap" gap={8} paddingX={16} paddingY={10}
              borderTop={idx > 0 ? 'default' : 'none'}
            >
              <Pane display="flex" alignItems="center" gap={12} flexWrap="wrap">
                <Text fontWeight="bold" size={400}>{r.operator_name}</Text>
                <Text size={300} color="muted">dal {fmtDate(r.from_date)} al {fmtDate(r.to_date)}</Text>
                <Text size={300}>{fmtTime(r.start_time)} – {fmtTime(r.end_time)}</Text>
                <Badge
                  color={PERIOD_COLORS[r.shift_period] || 'neutral'}
                  isSolid
                  style={r.shift_period === 'notte' ? { backgroundColor: '#1a1a1a', color: '#fff' } : {}}
                >
                  {PERIOD_LABELS[r.shift_period] || r.shift_period || '?'}
                </Badge>
                {!!Number(r.is_overtime) && <Badge color="purple" isSolid>Straordinario</Badge>}
                <Text size={300} color="muted">{r.shift_count} turni</Text>
              </Pane>
              <Pane display="flex" gap={8}>
                <IconButton icon={EditIcon} appearance="minimal" title="Modifica intervallo" onClick={() => onEdit(r)} />
                <IconButton icon={TrashIcon} appearance="minimal" intent="danger" title="Elimina intervallo" onClick={() => onDelete(r.batch_id)} />
              </Pane>
            </Pane>
          ))}
        </Pane>
      )}
    </Pane>
  );
}
